<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body[data-auth="true"] .desktop-login-btn,
body[data-auth="true"] .mobile-menu-login {
  display: none !important;
}

body:not([data-role="admin"]) a[href="/analytics"],
body:not([data-role="admin"]) a[href="/admin/dashboard"] {
  display: none !important;
}
</style>
